// Generated by ts-to-zod
import { z } from 'zod';
import { documentSchema } from '../models/document.schema';

export const documentPayloadSchema = documentSchema.partial();
